import axios from "axios";
import React, { useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { useFormik } from "formik";
import * as Yup from "yup";
import { getUser } from "../../utils/constants";
import { fetchDataFromAPI } from "../../utils/api";
import { toast } from "react-toastify";
import Processing from "../../components/Processing/Processing";
import moment from "moment";
import { Button, Modal, Pagination } from "react-bootstrap";

const DriverEdit = () => {
  const { state } = useLocation();
  const path = window.location.pathname.split("/")[1];

  const [loading, setLoading] = useState(false);
  const [forceUpdate, setForceUpdate] = useState(false);
  const [company, setCompany] = useState([]);
  const [showNewPass, setShowNewPass] = useState(false);
  const [showConNewPass, setShowConNewPass] = useState(false);
  const [showEditModal, setShowEditModal] = useState(false); // Fixed typo
  const [showIncompleteSignupModal, setShowIncompleteSignupModal] =
    useState(false);
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const [successData, setSuccessData] = useState({});
  const [showDeactivateModal, setShowDeactivateModal] = useState(false);
  const [deactivationReasonType, setDeactivationReasonType] =
    useState("DRIVER_GONE");
  const [deactivationReasonText, setDeactivationReasonText] = useState("");
  const [deactivationReasonError, setDeactivationReasonError] = useState("");
  const [showUpdateExistingModal, setShowUpdateExistingModal] = useState(false);
  const [pendingUpdate, setPendingUpdate] = useState(null);
  const [hasDuplicateRefError, setHasDuplicateRefError] = useState(false);
  const [duplicateErrorMessage, setDuplicateErrorMessage] = useState(""); // New state for error message
  const [showMissingRequirementsModal, setShowMissingRequirementsModal] =
    useState(false);
  const navigate = useNavigate();
  const user = JSON.parse(getUser());
  const initialStatusRef = React.useRef(
    state?.user?.icabbiStatus?.toString() || "0"
  );

  useEffect(() => {
    getDriversData();
    getCompany();
  }, []);
  useEffect(() => {
    if (showUpdateExistingModal) {
      formik.setFieldValue(
        "icabbi_driver_ref",
        state?.user?.icabbi_driver_ref || ""
      );
      const psvExpiry = formatDateForInput(state?.user?.psv_expiry);
      formik.setFieldValue("psv_expiry", psvExpiry || "");
    }
  }, [showUpdateExistingModal]);

  const formatDateForInput = (dateString) => {
    if (!dateString) return "";
    const date = new Date(dateString);
    return isNaN(date.getTime()) ? "" : date.toISOString().split("T")[0];
  };

  const formatDateOfBirthForInput = (dateString) => {

    if (!dateString) return "";

    const date = moment(
      dateString,
      [
        moment.ISO_8601,
        "YYYY-MM-DD",
        "DD/MM/YYYY",
      ],
      true
    );

    return date.isValid() ? date.format("YYYY-MM-DD") : "";
  };

  const formatDateOfBirthForAPI = (dateString) => {
    if (!dateString) return "";

    const date = moment(dateString, "YYYY-MM-DD", true);

    return date.isValid() ? date.format("DD/MM/YYYY") : "";
  };

  useEffect(() => {
    // Update initialStatusRef when state?.user?.icabbiStatus changes
    initialStatusRef.current = state?.user?.icabbiStatus?.toString() || "0";
  }, [state?.user?.icabbiStatus]);

  const getDriversData = () => {
    setLoading(true);
    const psvExpiry = formatDateForInput(state?.user?.psv_expiry);
    formik.setFieldValue("firstname", state?.user?.first_name || "");
    formik.setFieldValue("lastname", state?.user?.last_name || "");
    formik.setFieldValue("email", state?.user?.email || "");
    formik.setFieldValue("spsv", state?.user?.spsv || "");
    formik.setFieldValue(
      "icabbiStatus",
      state?.user?.icabbiStatus?.toString() || "0"
    );
    formik.setFieldValue(
      "icabbi_driver_app_pin",
      state?.user?.icabbi_driver_app_pin || ""
    );
    formik.setFieldValue(
      "icabbi_driver_ref",
      state?.user?.icabbi_driver_ref || ""
    );
    formik.setFieldValue("company_id", state?.user?.company_id || "");
    formik.setFieldValue("psv_expiry", psvExpiry || "");
    formik.setFieldValue("mobile_no", state?.user?.mobile_no || "");
    // formik.setFieldValue("date_of_birth", state?.user?.date_of_birth || "");
    formik.setFieldValue(
      "date_of_birth",
      formatDateOfBirthForInput(state?.user?.date_of_birth)
    );
    setLoading(false);
  };

  const validationSchemaNoActive = Yup.object().shape({
    firstname: Yup.string().required("Please enter first name"),
    lastname: Yup.string().required("Please enter last name"),
    email: Yup.string()
      .email("Please enter a valid email")
      .matches(
        /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Z|a-z]{2,}$/,
        "Email must end with .com"
      )
      .required("Please enter an email"),
    spsv: Yup.string().required("Please enter spsv"),
    icabbiStatus: Yup.string().notRequired(),
    icabbi_driver_ref: Yup.string().notRequired(),
    icabbi_driver_app_pin: Yup.string().notRequired(),
    newPass: Yup.string()
      .matches(/^.{8,}$/, "Password must be a minimum of 8 characters")
      .notRequired(),
    conNewPass: Yup.string()
      .oneOf(
        [Yup.ref("newPass"), null],
        "New password and repeat new password do not match."
      )
      .notRequired(),
    company_id: Yup.string().required("Please select a company"),
    psv_expiry: Yup.date().notRequired(),
  });

  const validationSchemaActive = Yup.object().shape({
    firstname: Yup.string().required("Please enter first name"),
    lastname: Yup.string().required("Please enter last name"),
    email: Yup.string()
      .email("Please enter a valid email")
      .matches(
        /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Z|a-z]{2,}$/,
        "Email must end with .com"
      )
      .required("Please enter an email"),
    spsv: Yup.string().required("Please enter spsv"),
    icabbiStatus: Yup.string().notRequired(),
    icabbi_driver_ref: Yup.string()
      .matches(/^[A-Za-z0-9]*$/, "Only letters and numbers are allowed")
      .required("Please enter an iCabbi Driver reference"),
    icabbi_driver_app_pin: Yup.string()
      .matches(/^[A-Za-z0-9]*$/, "Only letters and numbers are allowed")
      .required("Please enter an iCabbi Driver App Pin"),
    newPass: Yup.string()
      .matches(/^.{8,}$/, "Password must be a minimum of 8 characters")
      .notRequired(),
    conNewPass: Yup.string()
      .oneOf(
        [Yup.ref("newPass"), null],
        "New password and repeat new password do not match."
      )
      .notRequired(),
    company_id: Yup.string().required("Please select a company"),
    psv_expiry: Yup.date().required("Please select a PSV expiry date"),
  });

  const validationSchemaActiveModel = Yup.object().shape({
    firstname: Yup.string().required("Please enter first name"),
    lastname: Yup.string().required("Please enter last name"),
    email: Yup.string()
      .email("Please enter a valid email")
      .matches(
        /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Z|a-z]{2,}$/,
        "Email must end with .com"
      )
      .required("Please enter an email"),
    spsv: Yup.string().required("Please enter spsv"),
    icabbiStatus: Yup.string().notRequired(),
    icabbi_driver_ref: Yup.string()
      .matches(/^[A-Za-z0-9]*$/, "Only letters and numbers are allowed")
      .required("Please enter an iCabbi Driver reference"),
    icabbi_driver_app_pin: Yup.string()
      .matches(/^[A-Za-z0-9]*$/, "Only letters and numbers are allowed")
      .required("Please enter an iCabbi Driver App Pin"),
    newPass: Yup.string()
      .matches(/^.{8,}$/, "Password must be a minimum of 8 characters")
      .notRequired(),
    conNewPass: Yup.string()
      .oneOf(
        [Yup.ref("newPass"), null],
        "New password and repeat new password do not match."
      )
      .notRequired(),
    company_id: Yup.string().required("Please select a company"),
    psv_expiry: Yup.date().required("Please select a PSV expiry date"),
    reason: Yup.string().required("Please specify reason"),
  });

  const formik = useFormik({
    initialValues: {
      firstname: "",
      lastname: "",
      email: "",
      icabbiStatus: "",
      spsv: "",
      newPass: "",
      conNewPass: "",
      icabbi_driver_ref: "",
      icabbi_driver_app_pin: "",
      company_id: "",
      psv_expiry: new Date().toISOString().split("T")[0],
      reason: "",
      date_of_birth: "",
    },
    validationSchema:
      showEditModal || showIncompleteSignupModal
        ? validationSchemaActiveModel
        : state?.user?.icabbi_driver_app_pin && state?.user?.icabbi_driver_ref
          ? validationSchemaActive
          : validationSchemaNoActive,
    onSubmit: async (values) => {
      if (values?.newPass && !values?.conNewPass) {
        formik.setFieldError("conNewPass", "Please enter repeat new password");
        return;
      }

      if (
        values?.icabbiStatus === "0" &&
        deactivationReasonType === "OTHER" &&
        !(deactivationReasonText || "").trim()
      ) {
        toast.error("Please specify reason", {
          position: toast.POSITION.TOP_RIGHT,
          className: "bg-danger text-white",
        });
        setShowDeactivateModal(true);
        return;
      }

      if (hasDuplicateRefError) {
        setPendingUpdate({ values, admin: JSON.parse(getUser()) });
        setShowUpdateExistingModal(true);
        setShowEditModal(false);
        return;
      }

      setLoading(true);
      const admin = JSON.parse(getUser());

      const formData = new FormData();
      formData.append("id", state?.user?.user_id);
      formData.append("first_name", values?.firstname);
      formData.append("last_name", values?.lastname);
      formData.append("email", values?.email);
      formData.append("spsv", values?.spsv);
      formData.append("icabbiStatus", values?.icabbiStatus);
      formData.append("password", values?.conNewPass);
      formData.append("icabbi_driver_ref", values?.icabbi_driver_ref);
      formData.append("icabbi_driver_app_pin", values?.icabbi_driver_app_pin);
      formData.append("company_id", values?.company_id);
      // formData.append("is_update", "false");
      formData.append("is_update", forceUpdate ? "true" : "false");

      if (state?.user?.driver_status !== "Inactive") {
        formData.append("psv_expiry", values?.psv_expiry);
      }

      // formData.append("psv_expiry", values?.psv_expiry);
      formData.append("mobile_no", values?.mobile_no);
      // formData.append("date_of_birth", values?.date_of_birth || "");
      formData.append(
        "date_of_birth",
        formatDateOfBirthForAPI(values?.date_of_birth)
      );
      if (values?.icabbiStatus === "0") {
        const reasonTextCandidate =
          deactivationReasonType === "OTHER"
            ? (deactivationReasonText || "").trim()
            : "Driver Gone";
        if (reasonTextCandidate) {
          formData.append("notes", reasonTextCandidate);
        }
        const isDriverGone = deactivationReasonType === "DRIVER_GONE";
        formData.append("is_driver_gone", isDriverGone ? "true" : "false");
      } else {
        formData.append("notes", values?.reason);
      }

      if (
        values.icabbiStatus === "1" &&
        (!state?.user?.icabbi_driver_app_pin || !state?.user?.icabbi_driver_ref)
      ) {
        formData.append("is_active_icabbi", 1);
      } else {
        formData.append("is_active_icabbi", 0);
      }

      fetchDataFromAPI(
        "admin/profileUpdate",
        "post",
        formData,
        admin?.authToken
      )
        .then((res) => {
          setForceUpdate(false);
          setLoading(false);
          if (
            values?.icabbiStatus === "1" &&
            (state?.user?.driver_status === "Applicants" ||
              state?.user?.driver_status === "Ex-Drivers")
          ) {
            setSuccessData({
              icabbi_driver_ref:
                res.data?.icabbi_driver_ref || values?.icabbi_driver_ref,
              company_name: res.data?.company?.company_name || "",
              company_id: res.data?.company_id || values?.company_id,
              icabbiLink: res.data?.icabbiLink || "",
              user_id: res.data?.user_id,
              first_name: res.data?.first_name,
              last_name: res.data?.last_name,
              icabbi_driver_app_pin: res.data?.icabbi_driver_app_pin,
            });
            setShowSuccessModal(true);
          } else {
            toast.success("Driver updated successfully ✅", {
              position: toast.POSITION.TOP_RIGHT,
              className: "bg-success text-white",
            });
            navigate(`/${path}`);
          }
        })
        .catch((error) => {
          const errorMsg = error?.response?.data?.message;
          if (
            errorMsg &&
            (errorMsg.toLowerCase().includes("already") ||
              errorMsg.toLowerCase().includes("in use by another"))
          ) {
            setHasDuplicateRefError(true);
            setDuplicateErrorMessage(errorMsg); // Set the error message
            setPendingUpdate({ values, admin: JSON.parse(getUser()) });
            setShowUpdateExistingModal(true);
            setShowEditModal(false);
            setShowIncompleteSignupModal(false);
            setLoading(false);
            return;
          }
          setForceUpdate(false);
          setLoading(false);
          toast.error(error?.response?.data?.message, {
            position: toast.POSITION.TOP_RIGHT,
            className: "bg-danger text-white",
          });
          console.log("Error while updating member: ", error);
        });
    },
  });

  const handleCancelUpdateExisting = () => {
    formik.setFieldValue(
      "icabbi_driver_ref",
      state?.user?.icabbi_driver_ref || ""
    );
    setShowUpdateExistingModal(false);
    setPendingUpdate(null);
    setHasDuplicateRefError(false);
    setDuplicateErrorMessage("");
    // Clear the error message
    setShowEditModal(true);
  };

  useEffect(() => {
    const currentStatus = formik.values.icabbiStatus?.toString();
    const initialStatus = initialStatusRef.current?.toString();

    // Handle Active -> Inactive transition
    if (initialStatus === "1" && currentStatus === "0") {
      setShowDeactivateModal(true);
    }

    // Handle Inactive -> Active transition
    if (
      initialStatus === "0" &&
      currentStatus === "1" &&
      (state?.user?.driver_status === "Ex-Drivers" ||
        state?.user?.driver_status === "Applicants" ||
        state?.user?.driver_status === "Inactive")
    ) {
      setShowEditModal(true); // Open modal on Inactive -> Active
    } else if (
      currentStatus !== "1" ||
      (state?.user?.icabbi_driver_app_pin && state?.user?.icabbi_driver_ref)
    ) {
      setShowEditModal(false); // Close modal if status is not Active or both fields are present
    }
  }, [
    formik.values.icabbiStatus,
    state?.user?.icabbi_driver_app_pin,
    state?.user?.icabbi_driver_ref,
  ]);
  useEffect(() => {
    const currentStatus = formik.values.icabbiStatus?.toString();
    const initialStatus = initialStatusRef.current;

    const user = state?.user;

    // Only relevant when driver is "Incomplete Signups"
    if (user?.driver_status !== "Incomplete Signups") {
      setShowIncompleteSignupModal(false);
      setShowMissingRequirementsModal(false);
      return;
    }

    // Transition: Inactive → Active
    if (initialStatus === "0" && currentStatus === "1") {
      const hasMissingRequirements =
        !user?.document_uploaded ||
        !user?.is_iban_submitted ||
        !user?.agreement_verified;

      if (hasMissingRequirements) {
        // Show warning modal first
        setShowMissingRequirementsModal(true);
      } else {
        // All good → directly open edit modal
        setShowIncompleteSignupModal(true);
      }
    }
    // Transition: Active → Inactive
    else if (initialStatus === "1" && currentStatus === "0") {
      setShowDeactivateModal(true);
    }
    // Any other case (e.g. staying inactive, or already has refs exist)
    else {
      setShowIncompleteSignupModal(false);
      setShowMissingRequirementsModal(false);
    }
  }, [
    formik.values.icabbiStatus,
    state?.user?.driver_status,
    state?.user?.document_uploaded,
    state?.user?.is_iban_submitted,
    state?.user?.agreement_verified,
  ]);

  const formikActive = useFormik({
    initialValues: {
      icabbi_driver_ref: "",
      icabbi_driver_app_pin: "",
    },
    validationSchema: Yup.object({
      icabbi_driver_ref: Yup.string()
        .matches(/^[A-Za-z0-9]*$/, "Only letters and numbers are allowed")
        .required("Please enter reference"),
      icabbi_driver_app_pin: Yup.string()
        .matches(/^[A-Za-z0-9]*$/, "Only letters and numbers are allowed")
        .required("Please enter App Pin"),
    }),
    onSubmit: async (values) => {
      setLoading(true);
      const admin = JSON.parse(getUser());

      const formData = new FormData();
      formData.append("id", state?.user?.user_id);
      formData.append("first_name", values?.firstname);
      formData.append("last_name", values?.lastname);
      formData.append("email", values?.email);
      formData.append("spsv", values?.spsv);
      formData.append("icabbiStatus", values?.icabbiStatus);
      formData.append("password", values?.conNewPass);
      formData.append("icabbi_driver_ref", values?.icabbi_driver_ref);
      formData.append("icabbi_driver_app_pin", values?.icabbi_driver_app_pin);
      formData.append("psv_expiry", values?.psv_expiry);

      fetchDataFromAPI(
        "admin/profileUpdate",
        "post",
        formData,
        admin?.authToken
      )
        .then((res) => {
          console.log("=== API Response (formikActive) ===");
          console.log("Full response:", res);
          console.log("Response data:", res.data);
          console.log("Response status:", res.status);
          console.log("Response headers:", res.headers);
          console.log("Form values:", values);
          console.log("Form data entries:");
          for (let [key, value] of formData.entries()) {
            console.log(`${key}: ${value}`);
          }
          console.log("================================");

          setLoading(false);
          if (
            values?.icabbiStatus === "1" &&
            state?.user?.driver_status === "Applicants"
          ) {
            setSuccessData({
              icabbi_driver_ref:
                res.data?.icabbi_driver_ref || values?.icabbi_driver_ref,
              company_name: res.data?.company?.company_name || "",
              company_id: res.data?.company_id || values?.company_id,
              icabbiLink: res.data?.icabbiLink || "",
              user_id: res.data?.user_id,
              first_name: res.data?.first_name,
              last_name: res.data?.last_name,
              icabbi_driver_app_pin: res.data?.icabbi_driver_app_pin,
            });
            setShowSuccessModal(true);
          } else {
            toast.success("Driver updated successfully ✅", {
              position: toast.POSITION.TOP_RIGHT,
              className: "bg-success text-white",
            });
            navigate(`/${path}`);
          }
        })
        .catch((error) => {
          setLoading(false);
          toast.error(error?.response?.data?.message, {
            position: toast.POSITION.TOP_RIGHT,
            className: "bg-danger text-white",
          });
          console.log("Error while updating member: ", error);
        });
    },
  });

  const getCompany = () => {
    setLoading(true);
    fetchDataFromAPI(`company/getCompany`, "get", "", user?.authToken)
      .then((res) => {
        setCompany(res.data);
      })
      .catch((error) => {
        console.log("error", error);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  return (
    <>
      <main id="main" className="main">
        {loading && <Processing />}
        <div className="pagetitle">
          <nav>
            <ol className="breadcrumb">
              <li className="breadcrumb-item">
                <Link to="/">Dashboard</Link>
              </li>
              <li className="breadcrumb-item">
                <Link to={`/${path}`}>Drivers</Link>
              </li>
              <li className="breadcrumb-item active">
                {state?.user?.first_name} {""} {state?.user?.last_name}
              </li>
            </ol>
          </nav>
        </div>
        <section className="section profile">
          <div className="row">
            <div className="card">
              <div className="card-body pt-3">
                <div className="tab-content">
                  <div className="pt-3" id="profile-edit">
                    <form onSubmit={formik.handleSubmit}>
                      <div className="row mb-3"></div>
                      <div className="row mb-3">
                        <div className="col-md-4">
                          <label htmlFor="name" className="form-label">
                            First Name
                          </label>
                          <input
                            name="name"
                            type="text"
                            className="form-control"
                            id="name"
                            value={formik.values.firstname}
                            onChange={(e) => {
                              formik.setFieldValue(
                                "firstname",
                                e.target.value?.trimStart()
                              );
                            }}
                          />
                          {formik.touched.firstname &&
                            formik.errors.firstname && (
                              <div className="text-danger">
                                {formik.errors.firstname}
                              </div>
                            )}
                        </div>
                        <div className="col-md-4">
                          <label htmlFor="lastName" className="form-label">
                            Last Name
                          </label>
                          <input
                            name="lastname"
                            type="text"
                            className="form-control"
                            id="lastname"
                            value={formik.values.lastname}
                            onChange={(e) => {
                              formik.setFieldValue(
                                "lastname",
                                e.target.value?.trimStart()
                              );
                            }}
                          />
                          {formik.touched.lastname &&
                            formik.errors.lastname && (
                              <div className="text-danger">
                                {formik.errors.lastname}
                              </div>
                            )}
                        </div>
                        <div className="col-md-4">
                          <label htmlFor="mobile" className="form-label">
                            Mobile
                          </label>
                          <input
                            name="mobile"
                            type="text"
                            className="form-control"
                            id="mobile"
                            value={formik.values.mobile_no}
                            onChange={(e) => {
                              formik.setFieldValue(
                                "mobile_no",
                                e.target.value?.trimStart()
                              );
                            }}
                          />
                        </div>
                      </div>

                      <div className="row mb-3">
                        <div className="col-md-3">
                          <label htmlFor="email" className="form-label">
                            Email
                          </label>
                          <input
                            name="email"
                            type="text"
                            className="form-control"
                            id="email"
                            value={formik.values.email}
                            onChange={(e) => {
                              formik.setFieldValue(
                                "email",
                                e.target.value?.trimStart()
                              );
                            }}
                          />
                          {formik.touched.email && formik.errors.email && (
                            <div className="text-danger">
                              {formik.errors.email}
                            </div>
                          )}
                        </div>
                        <div className="col-md-3">
                          <label htmlFor="date_of_birth" className="form-label">
                            Date of Birth
                          </label>
                          <input
                            name="date_of_birth"
                            type="date"
                            className="form-control"
                            id="date_of_birth"
                            value={formik.values.date_of_birth}
                            onChange={(e) => {
                              formik.setFieldValue(
                                "date_of_birth",
                                e.target.value?.trimStart()
                              );
                            }}
                          />
                        </div>
                        <div className="col-md-3">
                          <label htmlFor="gender" className="form-label">
                            Gender
                          </label>
                          <input
                            name="gender"
                            type="text"
                            className="form-control"
                            disabled
                            id="gender"
                            value={formik.values.gender || "-"}
                            onChange={(e) => {
                              formik.setFieldValue(
                                "gender",
                                e.target.value?.trimStart()
                              );
                            }}
                          />
                        </div>
                        <div className="col-md-3">
                          <label
                            htmlFor="SPSVLicenceNumber"
                            className="form-label"
                          >
                            SPSV Licence Number
                          </label>
                          <input
                            name="SPSVLicenceNumber"
                            type="text"
                            className="form-control"
                            id="SPSVLicenceNumber"
                            value={formik.values.spsv}
                            onChange={(e) => {
                              formik.setFieldValue(
                                "spsv",
                                e.target.value?.trimStart()
                              );
                            }}
                          />
                          {formik.touched.spsv && formik.errors.spsv && (
                            <div className="text-danger">
                              {formik.errors.spsv}
                            </div>
                          )}
                        </div>
                      </div>

                      <div className="row mb-3">
                        <div className="col-md-3">
                          <label
                            htmlFor="AgreementVersion"
                            className="form-label"
                          >
                            Agreement Version
                          </label>
                          <input
                            disabled
                            name="AgreementVersion"
                            type="text"
                            className="form-control"
                            id="AgreementVersion"
                            value={
                              state?.user?.agreement_version
                                ? state?.user?.agreement_version
                                : "-"
                            }
                          />
                        </div>
                        <div className="col-md-3">
                          <label htmlFor="DateSigned" className="form-label">
                            Date Accepted
                          </label>
                          <input
                            disabled
                            name="DateSigned"
                            type="text"
                            className="form-control"
                            id="DateSigned"
                            value={
                              state?.user?.agreement_signed &&
                                state.user.agreement_signed !== ""
                                ? moment(state.user.agreement_signed).format(
                                  "YYYY-MM-DD HH:mm:ss"
                                )
                                : "Not Accepted Yet"
                            }
                          />
                        </div>
                        <div className="col-md-3">
                          <label htmlFor="icabbiStatus" className="form-label">
                            iCabbi Status
                          </label>
                          <div className="input-group">
                            <select
                              name="icabbiStatus"
                              className="form-select"
                              id="icabbiStatus"
                              value={formik.values.icabbiStatus}
                              onChange={(e) => {
                                formik.setFieldValue(
                                  "icabbiStatus",
                                  e.target.value
                                );
                              }}
                              aria-label="Select icabbiStatus"
                            >
                              <option value="0">Inactive</option>
                              <option value="1">Active</option>
                            </select>
                          </div>
                        </div>
                        <div className="col-md-3">
                          <label htmlFor="company_id" className="form-label">
                            Company
                          </label>
                          <div className="input-group">
                            <select
                              name="company_id"
                              className="form-select"
                              id="company_id"
                              {...formik.getFieldProps("company_id")}
                              aria-label="Select Company"
                            >
                              <option value="">Select a Company</option>
                              {company?.map((company, index) => (
                                <option key={index} value={company?.company_id}>
                                  {company?.company_name}
                                </option>
                              ))}
                            </select>
                          </div>
                          {formik.touched.company_id &&
                            formik.errors.company_id && (
                              <div className="text-danger">
                                {formik.errors.company_id}
                              </div>
                            )}
                        </div>
                      </div>

                      {state?.user?.icabbi_driver_app_pin &&
                        state?.user?.icabbi_driver_ref && (
                          <div className="row mb-3">
                            <div className="col-md-6">
                              <label
                                htmlFor="icabbi_driver_ref"
                                className="form-label"
                              >
                                iCabbi Driver Ref
                              </label>
                              <input
                                name="icabbi_driver_ref"
                                type="text"
                                className="form-control"
                                id="icabbi_driver_ref"
                                value={formik.values.icabbi_driver_ref}
                                onChange={(e) => {
                                  formik.setFieldValue(
                                    "icabbi_driver_ref",
                                    e.target.value?.trimStart().toUpperCase()
                                  );
                                  setHasDuplicateRefError(false);
                                  setDuplicateErrorMessage(""); // Clear error when changing
                                }}
                              />
                              {formik.touched.icabbi_driver_ref &&
                                formik.errors.icabbi_driver_ref && (
                                  <div className="text-danger">
                                    {formik.errors.icabbi_driver_ref}
                                  </div>
                                )}
                            </div>
                            <div className="col-md-6">
                              <label
                                htmlFor="icabbi_driver_app_pin"
                                className="form-label"
                              >
                                iCabbi Driver App Pin
                              </label>
                              <input
                                name="icabbi_driver_app_pin"
                                type="text"
                                className="form-control"
                                id="icabbi_driver_app_pin"
                                value={formik.values.icabbi_driver_app_pin}
                                onChange={(e) => {
                                  formik.setFieldValue(
                                    "icabbi_driver_app_pin",
                                    e.target.value?.trimStart().toUpperCase()
                                  );
                                }}
                              />
                              {formik.touched.icabbi_driver_app_pin &&
                                formik.errors.icabbi_driver_app_pin && (
                                  <div className="text-danger">
                                    {formik.errors.icabbi_driver_app_pin}
                                  </div>
                                )}
                            </div>
                          </div>
                        )}

                      <div className="row mb-3">
                        <div className="col-md-3">
                          <label htmlFor="ios/android" className="form-label">
                            iOS/Android
                          </label>
                          <input
                            disabled
                            name="ios/android"
                            type="text"
                            className="form-control"
                            id="ios/android"
                            value={state?.user?.device_type}
                          />
                        </div>
                        <div className="col-md-3">
                          <label
                            htmlFor="RegistrationTimestamp"
                            className="form-label"
                          >
                            Registration Timestamp
                          </label>
                          <input
                            disabled
                            name="RegistrationTimestamp"
                            type="text"
                            className="form-control"
                            id="RegistrationTimestamp"
                            value={moment(
                              state?.user?.registrationTimestamp
                            ).format("YYYY-MM-DD HH:mm:ss")}
                          />
                        </div>
                        <div className="col-md-3">
                          <label
                            htmlFor="clicked_to_app"
                            className="form-label"
                          >
                            Clicked to App
                          </label>
                          <input
                            disabled
                            name="clicked_to_app"
                            type="text"
                            className="form-control"
                            id="clicked_to_app"
                            value={
                              state?.user?.clicked_to_app
                                ? state?.user?.clicked_to_app
                                : "No"
                            }
                          />
                        </div>
                        <div className="col-md-3">
                          <label
                            htmlFor="SignUpComplete"
                            className="form-label"
                          >
                            Sign Up Complete
                          </label>
                          <input
                            disabled
                            name="SignUpComplete"
                            type="text"
                            className="form-control"
                            id="SignUpComplete"
                            value={state?.user?.registrationComplete}
                          />
                        </div>
                      </div>

                      <div className="row mb-3">
                        <div className="col-md-12">
                          <label htmlFor="address" className="form-label">
                            Address
                          </label>
                          <textarea
                            disabled
                            name="address"
                            type="text"
                            className="form-control"
                            id="address"
                            value={state?.user?.address}
                          />
                        </div>
                      </div>

                      <label>Change Password</label>
                      <hr className="mt-0" />
                      <div className="row mb-3">
                        <div className="col-md-6">
                          <label htmlFor="newPass" className="form-label">
                            New Password
                          </label>
                          <div className="d-flex">
                            <input
                              name="newPass"
                              type={showNewPass ? "text" : "password"}
                              className="form-control"
                              style={{
                                borderTopRightRadius: "0",
                                borderBottomRightRadius: "0",
                              }}
                              id="newPass"
                              onChange={(e) => {
                                formik.setFieldValue(
                                  "newPass",
                                  e.target.value?.trimStart()
                                );
                              }}
                            />
                            <button
                              type="button"
                              className="btn btn-outline-secondary"
                              style={{
                                borderTopLeftRadius: "0",
                                borderBottomLeftRadius: "0",
                              }}
                              onClick={() => setShowNewPass(!showNewPass)}
                            >
                              {showNewPass ? (
                                <i className="bi bi-eye-fill"></i>
                              ) : (
                                <i className="bi bi-eye-slash-fill"></i>
                              )}
                            </button>
                          </div>
                          {formik.touched.newPass && formik.errors.newPass && (
                            <div className="text-danger">
                              {formik.errors.newPass}
                            </div>
                          )}
                        </div>
                        <div className="col-md-6">
                          <label htmlFor="conNewPass" className="form-label">
                            Repeat New Password
                          </label>
                          <div className="d-flex">
                            <input
                              name="conNewPass"
                              type={showConNewPass ? "text" : "password"}
                              className="form-control"
                              style={{
                                borderTopRightRadius: "0",
                                borderBottomRightRadius: "0",
                              }}
                              id="conNewPass"
                              onChange={(e) => {
                                formik.setFieldValue(
                                  "conNewPass",
                                  e.target.value?.trimStart()
                                );
                              }}
                            />
                            <button
                              type="button"
                              className="btn btn-outline-secondary"
                              style={{
                                borderTopLeftRadius: "0",
                                borderBottomLeftRadius: "0",
                              }}
                              onClick={() => setShowConNewPass(!showConNewPass)}
                            >
                              {showConNewPass ? (
                                <i className="bi bi-eye-fill"></i>
                              ) : (
                                <i className="bi bi-eye-slash-fill"></i>
                              )}
                            </button>
                          </div>
                          {formik.touched.conNewPass &&
                            formik.errors.conNewPass && (
                              <div className="text-danger">
                                {formik.errors.conNewPass}
                              </div>
                            )}
                        </div>
                      </div>

                      <div className="text-center">
                        <button type="submit" className="btn btn-warning">
                          {!loading && (
                            <span className="indicator-label">
                              Save Updates
                            </span>
                          )}
                          {loading && (
                            <span
                              className="indicator-progress"
                              style={{ display: "block" }}
                            >
                              Please wait...
                              <span className="spinner-border spinner-border-sm align-middle ms-2"></span>
                            </span>
                          )}
                        </button>
                      </div>
                    </form>
                  </div>
                  <div
                    className="tab-pane fade pt-3"
                    id="profile-settings"
                  ></div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>
      <Modal
        show={showMissingRequirementsModal}
        centered
        onHide={() => {
          setShowMissingRequirementsModal(false);
          formik.setFieldValue("icabbiStatus", "0");
        }}
      >
        <Modal.Header closeButton>
          <Modal.Title>Missing Requirements</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {(() => {
            const missing = [];
            if (!state?.user?.document_uploaded)
              missing.push("Documents not uploaded");
            if (!state?.user?.is_iban_submitted)
              missing.push("IBAN not submitted");
            if (!state?.user?.agreement_verified)
              missing.push("Agreement not accepted/verified");

            return (
              <>
                <p className="mb-3">
                  The driver is missing the following required items:
                </p>
                <ul className="text-danger fw-medium mb-4">
                  {missing.map((item, i) => (
                    <li key={i}>{item}</li>
                  ))}
                </ul>
                <p>Are you sure you want to update the record?</p>
              </>
            );
          })()}
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="secondary"
            onClick={() => {
              setShowMissingRequirementsModal(false);
              formik.setFieldValue("icabbiStatus", "0");
            }}
          >
            Cancel
          </Button>
          <Button
            // variant="warning"
            onClick={() => {
              setShowMissingRequirementsModal(false);
              setShowIncompleteSignupModal(true);
            }}
          >
            Yes
          </Button>
        </Modal.Footer>
      </Modal>
      <Modal
        show={showEditModal}
        centered
        onHide={() => {
          formik.resetForm();
          setShowEditModal(false);
          formik.setFieldValue("icabbiStatus", "0");
          getDriversData();
        }}
      >
        <Modal.Header closeButton>
          <Modal.Title>Edit Driver</Modal.Title>
        </Modal.Header>
        <Modal.Body className="">
          <div className="d-flex gap-2">
            <div className="col-md-6">
              <label htmlFor="icabbi_driver_ref" className="form-label">
                iCabbi Driver Ref
              </label>
              <input
                name="icabbi_driver_ref"
                type="text"
                className="form-control"
                id="icabbi_driver_ref"
                value={formik.values.icabbi_driver_ref}
                onChange={(e) => {
                  formik.setFieldValue(
                    "icabbi_driver_ref",
                    e.target.value?.trimStart()?.toUpperCase()
                  );
                  setHasDuplicateRefError(false);
                  setDuplicateErrorMessage(""); // Clear error when changing
                }}
              />
              {formik.touched.icabbi_driver_ref &&
                formik.errors.icabbi_driver_ref && (
                  <div className="text-danger">
                    {formik.errors.icabbi_driver_ref}
                  </div>
                )}
            </div>
            <div className="col-md-6">
              <label htmlFor="icabbi_driver_app_pin" className="form-label">
                iCabbi Driver App PIN
              </label>
              <input
                name="icabbi_driver_app_pin"
                type="text"
                className="form-control"
                id="icabbi_driver_app_pin"
                value={formik.values.icabbi_driver_app_pin}
                onChange={(e) => {
                  formik.setFieldValue(
                    "icabbi_driver_app_pin",
                    e.target.value?.trimStart()?.toUpperCase()
                  );
                }}
              />
              {formik.touched.icabbi_driver_app_pin &&
                formik.errors.icabbi_driver_app_pin && (
                  <div className="text-danger">
                    {formik.errors.icabbi_driver_app_pin}
                  </div>
                )}
            </div>
          </div>
          <div className="d-flex gap-2">
            <div className="col-md-12 mt-2">
              <label htmlFor="company_id" className="form-label">
                Company
              </label>
              <div className="input-group">
                <select
                  name="company_id"
                  className="form-select"
                  id="company_id"
                  {...formik.getFieldProps("company_id")}
                  aria-label="Select Company"
                >
                  <option value="">Select a Company</option>
                  {company?.map((company, index) => (
                    <option key={index} value={company?.company_id}>
                      {company?.company_name}
                    </option>
                  ))}
                </select>
              </div>
              {formik.touched.company_id && formik.errors.company_id && (
                <div className="text-danger">{formik.errors.company_id}</div>
              )}
            </div>
          </div>
          {state?.user?.driver_status !== "Inactive" && (
            <div className="d-flex gap-2">
              <div className="col-md-12 mt-2">
                <label htmlFor="date" className="form-label">
                  PSV expiry date
                </label>
                <div className="input-group">
                  <input
                    type="date"
                    name="psv_expiry"
                    className={`form-control ${formik.touched.psv_expiry && formik.errors.psv_expiry
                      ? "is-invalid"
                      : ""
                      }`}
                    id="psv_expiry"
                    min={new Date().toISOString().split("T")[0]}
                    {...formik.getFieldProps("psv_expiry")}
                    aria-label="Select Date"
                  />
                </div>
                {formik.touched.psv_expiry && formik.errors.psv_expiry && (
                  <div className="text-danger">{formik.errors.psv_expiry}</div>
                )}
              </div>
            </div>
          )}
          <div className="d-flex gap-2">
            <div className="col-md-12 mt-2">
              <label htmlFor="reason" className="form-label">
                Reason
              </label>
              <input
                name="reason"
                type="text"
                className="form-control"
                id="reason"
                value={formik.values.reason}
                onChange={(e) => {
                  formik.setFieldValue("reason", e.target.value?.trimStart());
                }}
              />
              {formik.touched.reason && formik.errors.reason && (
                <div className="text-danger">{formik.errors.reason}</div>
              )}
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer className="text-end gap-1 border-0 px-3 py-2">
          <Button
            variant="secondary"
            onClick={() => {
              formik.resetForm();
              setShowEditModal(false);
              formik.setFieldValue("icabbiStatus", "0");
              getDriversData();
            }}
          >
            Cancel
          </Button>
          <Button
            variant="danger"
            onClick={() => {
              formik.validateForm().then((errors) => {
                if (Object.keys(errors).length === 0) {
                  formik.handleSubmit();
                } else {
                  toast.error("Please fill all required fields correctly", {
                    position: toast.POSITION.TOP_RIGHT,
                    className: "bg-danger text-white",
                  });
                }
              });
            }}
          >
            Update
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal
        show={showDeactivateModal}
        centered
        onHide={() => {
          setShowDeactivateModal(false);
          formik.setFieldValue("icabbiStatus", "1");
          setDeactivationReasonType("DRIVER_GONE");
          setDeactivationReasonText("");
        }}
      >
        <Modal.Header closeButton>
          <Modal.Title>Deactivate Driver</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="mb-2">Reason for Deactivation:</div>
          <div className="form-check">
            <input
              className="form-check-input"
              type="radio"
              name="deactivationReason"
              id="reasonDriverGone"
              value="DRIVER_GONE"
              checked={deactivationReasonType === "DRIVER_GONE"}
              onChange={() => {
                setDeactivationReasonType("DRIVER_GONE");
                setDeactivationReasonError("");
              }}
            />
            <label className="form-check-label" htmlFor="reasonDriverGone">
              Driver Gone
            </label>
          </div>
          <div className="form-check mt-2">
            <input
              className="form-check-input"
              type="radio"
              name="deactivationReason"
              id="reasonOther"
              value="OTHER"
              checked={deactivationReasonType === "OTHER"}
              onChange={() => {
                setDeactivationReasonType("OTHER");
              }}
            />
            <label className="form-check-label" htmlFor="reasonOther">
              Other
            </label>
          </div>
          {deactivationReasonType === "OTHER" && (
            <div className="mt-3">
              <label htmlFor="deactivationReasonText" className="form-label">
                Please specify reason
              </label>
              <textarea
                className="form-control"
                id="deactivationReasonText"
                placeholder="Enter reason"
                rows={3}
                value={deactivationReasonText}
                onChange={(e) => {
                  setDeactivationReasonText(e.target.value);
                  if ((e.target.value || "").trim()) {
                    setDeactivationReasonError("");
                  }
                }}
              />
              {deactivationReasonError && (
                <div className="text-danger small mt-1">
                  {deactivationReasonError}
                </div>
              )}
            </div>
          )}
        </Modal.Body>
        <Modal.Footer className="text-end gap-1 border-0 px-3 py-2">
          <Button
            variant="secondary"
            onClick={() => {
              setShowDeactivateModal(false);
              formik.setFieldValue("icabbiStatus", "1");
              setDeactivationReasonType("DRIVER_GONE");
              setDeactivationReasonText("");
              setDeactivationReasonError("");
            }}
          >
            Cancel
          </Button>
          <Button
            variant="danger"
            onClick={() => {
              if (
                deactivationReasonType === "OTHER" &&
                !(deactivationReasonText || "").trim()
              ) {
                setDeactivationReasonError("Please specify reason");
                return;
              }
              setShowDeactivateModal(false);
            }}
          >
            Save
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal
        show={showUpdateExistingModal}
        centered
        onHide={handleCancelUpdateExisting}
      >
        <Modal.Header closeButton>
          <Modal.Title>Update Existing Record</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>
            {duplicateErrorMessage}. Would you like to update the existing
            record?
          </p>
        </Modal.Body>
        <Modal.Footer className="text-end gap-1 border-0 px-3 py-2">
          <Button variant="secondary" onClick={handleCancelUpdateExisting}>
            Cancel
          </Button>
          <Button
            variant="primary"
            onClick={() => {
              setForceUpdate(true);
              setHasDuplicateRefError(false);
              setShowUpdateExistingModal(false);
              formik.handleSubmit();
            }}
          >
            Yes
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal
        show={showSuccessModal}
        centered
        onHide={() => {
          setShowSuccessModal(false);
          navigate(`/${path}`);
        }}
        size="lg"
      >
        <Modal.Header closeButton>
          <Modal.Title style={{ color: "#ffc107" }}>
            <i className="bi bi-check-circle-fill me-2"></i>
            DRIVER SAVED
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="p-4">
          <div
            className="alert alert-warning mb-4"
            style={{
              backgroundColor: "#ffc107",
              color: "#000",
              borderColor: "#ffc107",
            }}
          >
            <strong>{successData.icabbi_driver_ref}</strong> driver{" "}
            {state?.user?.driver_status === "Ex-Drivers"
              ? "re-activated "
              : "set up "}
            in the Lynk Driver App Admin Panel and iCabbi.
          </div>
          <div className="mb-4">
            <h6 className="fw-bold mb-3">
              NB: To complete the driver set up, go to the driver record in
              iCabbi by clicking{" "}
              <a
                href={successData.icabbiLink}
                target="_blank"
                rel="noopener noreferrer"
              >
                here
              </a>{" "}
              and:
            </h6>
            <ol className="ps-3">
              <li className="mb-2">
                Click on the correct template to automatically set the
                information for:{" "}
                <strong>
                  Attributes, Device Locked, Invoiced, Output Pref, Payment
                  Type, Invoice Footer, Shifts.
                </strong>
              </li>
              <li className="mb-2 ">
                Double check that the PIN is:{" "}
                <span className="fw-bold">
                  {successData.icabbi_driver_app_pin}
                </span>
              </li>
              <li className="mb-2">
                Set SIID: <strong>{successData.icabbi_driver_ref}</strong>
              </li>
              <li className="mb-2">Upload the Profile Photo.</li>
              <li className="mb-2">Click "Save Driver".</li>
              <li className="mb-2">
                Go to Sites {"->"} Click on the correct template for site{" "}
                <strong>{successData.company_name}</strong> to automatically
                select the right Sites {"->"} Click "Save"
              </li>
              <li className="mb-2">
                Attach the Correct Vehicle to the driver.
              </li>
            </ol>
          </div>
          <div className="d-flex justify-content-end gap-3">
            <Button
              style={{
                backgroundColor: "#ffc107",
                color: "#000",
                borderColor: "#ffc107",
              }}
              onClick={() => {
                setShowSuccessModal(false);
                navigate(`/${path}`);
              }}
            >
              Done
            </Button>
          </div>
        </Modal.Body>
      </Modal>
      <Modal
        show={showIncompleteSignupModal}
        centered
        onHide={() => {
          formik.resetForm();
          setShowIncompleteSignupModal(false);
          formik.setFieldValue("icabbiStatus", "0");
          getDriversData();
        }}
      >
        <Modal.Header closeButton>
          <Modal.Title>Edit Driver</Modal.Title>
        </Modal.Header>
        <Modal.Body className="">
          <div className="d-flex gap-2">
            <div className="col-md-6">
              <label htmlFor="icabbi_driver_ref" className="form-label">
                iCabbi Driver Ref
              </label>
              <input
                name="icabbi_driver_ref"
                type="text"
                className="form-control"
                id="icabbi_driver_ref"
                value={formik.values.icabbi_driver_ref}
                onChange={(e) => {
                  formik.setFieldValue(
                    "icabbi_driver_ref",
                    e.target.value?.trimStart()?.toUpperCase()
                  );
                  setHasDuplicateRefError(false);
                  setDuplicateErrorMessage(""); // Clear error when changing
                }}
              />
              {formik.touched.icabbi_driver_ref &&
                formik.errors.icabbi_driver_ref && (
                  <div className="text-danger">
                    {formik.errors.icabbi_driver_ref}
                  </div>
                )}
            </div>
            <div className="col-md-6">
              <label htmlFor="icabbi_driver_app_pin" className="form-label">
                iCabbi Driver App PIN
              </label>
              <input
                name="icabbi_driver_app_pin"
                type="text"
                className="form-control"
                id="icabbi_driver_app_pin"
                value={formik.values.icabbi_driver_app_pin}
                onChange={(e) => {
                  formik.setFieldValue(
                    "icabbi_driver_app_pin",
                    e.target.value?.trimStart()?.toUpperCase()
                  );
                }}
              />
              {formik.touched.icabbi_driver_app_pin &&
                formik.errors.icabbi_driver_app_pin && (
                  <div className="text-danger">
                    {formik.errors.icabbi_driver_app_pin}
                  </div>
                )}
            </div>
          </div>
          <div className="d-flex gap-2">
            <div className="col-md-12 mt-2">
              <label htmlFor="company_id" className="form-label">
                Company
              </label>
              <div className="input-group">
                <select
                  name="company_id"
                  className="form-select"
                  id="company_id"
                  {...formik.getFieldProps("company_id")}
                  aria-label="Select Company"
                >
                  <option value="">Select a Company</option>
                  {company?.map((company, index) => (
                    <option key={index} value={company?.company_id}>
                      {company?.company_name}
                    </option>
                  ))}
                </select>
              </div>
              {formik.touched.company_id && formik.errors.company_id && (
                <div className="text-danger">{formik.errors.company_id}</div>
              )}
            </div>
          </div>
          {state?.user?.driver_status !== "Inactive" && (
            <div className="d-flex gap-2">
              <div className="col-md-12 mt-2">
                <label htmlFor="date" className="form-label">
                  PSV expiry date
                </label>
                <div className="input-group">
                  <input
                    type="date"
                    name="psv_expiry"
                    className={`form-control ${formik.touched.psv_expiry && formik.errors.psv_expiry
                      ? "is-invalid"
                      : ""
                      }`}
                    id="psv_expiry"
                    min={new Date().toISOString().split("T")[0]}
                    {...formik.getFieldProps("psv_expiry")}
                    aria-label="Select Date"
                  />
                </div>
                {formik.touched.psv_expiry && formik.errors.psv_expiry && (
                  <div className="text-danger">{formik.errors.psv_expiry}</div>
                )}
              </div>
            </div>
          )}
          <div className="d-flex gap-2">
            <div className="col-md-12 mt-2">
              <label htmlFor="reason" className="form-label">
                Reason
              </label>
              <input
                name="reason"
                type="text"
                className="form-control"
                id="reason"
                value={formik.values.reason}
                onChange={(e) =>
                  formik.setFieldValue("reason", e.target.value?.trimStart())
                }
              />
              {formik.touched.reason && formik.errors.reason && (
                <div className="text-danger">{formik.errors.reason}</div>
              )}
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer className="text-end gap-1 border-0 px-3 py-2">
          <Button
            variant="secondary"
            onClick={() => {
              formik.resetForm();
              setShowIncompleteSignupModal(false);
              // setShowEditModal(false);
              formik.setFieldValue("icabbiStatus", "0");
              getDriversData();
            }}
          >
            Cancel
          </Button>
          <Button
            variant="danger"
            onClick={() => {
              formik.validateForm().then((errors) => {
                if (Object.keys(errors).length === 0) {
                  formik.handleSubmit();
                } else {
                  toast.error("Please fill all required fields correctly", {
                    position: toast.POSITION.TOP_RIGHT,
                    className: "bg-danger text-white",
                  });
                }
              });
            }}
          >
            Update
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default DriverEdit;
